/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wry_Calm_Puma_ClipInputs */

const en_wry_calm_puma_clip = /** @type {(inputs: Wry_Calm_Puma_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add user`)
};

const de_wry_calm_puma_clip = /** @type {(inputs: Wry_Calm_Puma_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add user" |
*
* @param {Wry_Calm_Puma_ClipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wry_calm_puma_clip = /** @type {((inputs?: Wry_Calm_Puma_ClipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wry_Calm_Puma_ClipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wry_calm_puma_clip(inputs)
	return de_wry_calm_puma_clip(inputs)
});